<div class="segmented-control" [class.disabled]="disabled">
	<button
		*ngFor="let option of options; trackBy: trackByOptionValue"
		type="button"
		class="segmented-btn"
		[class.active]="isActive(option.value)"
		[disabled]="isOptionDisabled(option)"
		(click)="onButtonClick(option)">
		{{ option.label }}
	</button>
</div>

